import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as AplGroupActions from './apl-group.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class AplGroupStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new AplGroupActions.APLGroupRefresh());
    this.store.dispatch(new AplGroupActions.APLGroupAllPendingRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.APLGROUP, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new AplGroupActions.APLGroupCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new AplGroupActions.APLGroupUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new AplGroupActions.APLGroupDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new AplGroupActions.APLGroupRefresh());
          this.store.dispatch(new AplGroupActions.APLGroupAllPendingRefresh());
          break;

      }
    });

  }
}
